// extracted by mini-css-extract-plugin
module.exports = {"layout":"base-module--layout--1mWgb","layout__backLink":"base-module--layout__back-link--zJawW"};